import { supabase } from '@/core/database/supabase';
import type { EquipmentAsset, EquipmentUsageLog } from '../../types/equipment.types';

export const equipmentDetailService = {
  async getEquipmentDetail(id: string): Promise<EquipmentAsset | null> {
    const { data, error } = await supabase
      .from('equipment_assets')
      .select(`
        *,
        group:equipment_groups(id, name),
        assigned_to:user_profiles!assigned_to_id(id, full_name, avatar_path),
        project:projects!project_id(id, name)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  },

  async getUsageLogs(assetId: string): Promise<EquipmentUsageLog[]> {
    const { data, error } = await supabase
      .from('equipment_usage_logs')
      .select(`
        *,
        project:projects(name),
        user:user_profiles(full_name)
      `)
      .eq('asset_id', assetId)
      .order('start_time', { ascending: false })
      .limit(10);

    if (error) throw error;
    return data as any;
  }
};
